export default function isValidEmailAddress(text) {
    if (text === void 0) { text = ''; }
    // use a rudimentary check, backend does the proper legwork
    // this is just to get the most obviously wrong cases out
    if (text.length > 255) {
        return false;
    }
    // regex copied from backend
    return /^([^@ \\,\(\),\:;\<\>\[\]]+)@([^\.@ ]+\.[^@ ]+)$/.test(text);
}
//# sourceMappingURL=isValidEmailAddress.js.map